import React from 'react';
import PropTypes from 'prop-types';
import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { noop } from 'ui-components/default-props/noop';
import CustomerRecipientWidget, { displayHeader } from '../../../../orders/customer-recipient-widget/component';
import { usePickupRelayOrderInfoBySalesOrderId } from '../../../../hooks/orders/use-pickup-relay-order-check';
import { getCustomerSummary } from './get-customer-summary';

import style from './customer.module.css';

const Customer = ({ salesOrderId, currentFulfillmentPlanId, open = false, onClick = noop, dragHandleProps, shipTo }) => {
  const isPickupRelayOrder = usePickupRelayOrderInfoBySalesOrderId(salesOrderId) !== null;

  return (
    <CollapsibleListSection open={open}>
      <CollapsibleListSectionHeader
        dragHandleProps={dragHandleProps}
        onClick={() => onClick(open)}
        summaryData={getCustomerSummary(shipTo, open)}
        summaryDataStyle={style['summary-data']}
        theme='white'
      >
        {displayHeader(isPickupRelayOrder)}
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>
        <div className={style['customer-section']}>
          <CustomerRecipientWidget key={salesOrderId} salesOrderId={salesOrderId} selectedFulfillmentPlanId={currentFulfillmentPlanId} />
        </div>
      </CollapsibleListSectionContent>
    </CollapsibleListSection>
  );
};

Customer.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  shipTo: PropTypes.object.isRequired,
  salesOrderId: PropTypes.string.isRequired,
  currentFulfillmentPlanId: PropTypes.string.isRequired,
  dragHandleProps: PropTypes.object,
};

export default Customer;
